<template>
  <!-- banner topo -->
  <div v-if="bannerTopo != ''" class="bannerTopo-area">
    <div class="bannerTopo-height d-flex align-items-center">

      <div class="bannerTopo-img">
        <img :src="$imgURL + bannerTopo[0].insInstitucionalImagens[0].itgUrlImagem" class="bannerTopo-bg-fill" alt="">
      </div>

      <div class="bannerTopo-overlay"></div>

      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xl-8 col-lg-10">
            <div class="bannerTopo-caption text-center">
              <h2>{{ bannerTopo[0].itiNome }}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- noticia selecionada -->
  <section v-if="linhaTextoNoticia != ''" class="blog_area single-post-area section-padding">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-8 posts-list">
          <div class="single-post">
            <div class="feature-img">
              <img :src="$imgURL + linhaTextoNoticia.insInstitucionalImagens[0].itgUrlImagem" class="img-fluid">
            </div>
            <div class="blog_details">
              <h2>{{ linhaTextoNoticia.itiNome }}</h2>
              <p v-html="linhaTextoNoticia.itiResumo1"></p>
              <div class="voltar-container">
                <p class="voltar-link" onclick="history.back()" style="cursor: pointer; ">
                  <i class="fas fa-arrow-left"></i> Voltar
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

</template>

<script>
import { useRoute } from 'vue-router';
import { useHead } from '@vueuse/head'
import axios from 'axios';

export default {
  name: 'BlogDetalheView',
  components: {
  },

  setup() {
    const route = useRoute();
    const id = route.params.id;
    const nome = route.params.nome;
    return {
      id,
      nome
    };
  },

  data: () => ({

    bannerTopo: [],
    linhaTextoNoticia: [],
    listaNoticias: [],

  }),
  methods: {
    formataLink(value) {
      return value.replaceAll('/', '').replaceAll(' ', '-').replaceAll('.', '').replaceAll('+', '');
    },

    carregaMetas(texto, titulo) {
      useHead({
        title: 'Lukon :: ' + titulo,
        meta: [
          { name: "description", content: texto },
          { name: "author", content: "Avance Digital" },
          { httpEquiv: "Content-Language", content: "pt-BR" },
          { charset: "UTF-8" },
          { name: "robots", content: "index, follow" },
        ],
      })
    },

    removerTagsHTML(html) {
      const element = document.createElement('div');
      element.innerHTML = html;
      return element.textContent || element.innerText || '';
    },
  },

  created() {

    // TOPO BANNER
    axios.get('/Process/InsInstitucional/institucional/27/toponoticias/0/x')
      .then(response => {
        this.bannerTopo = response.data;
        this.carregaMetas(this.removerTagsHTML, this.bannerTopo[0].itiNome);
        //console.log('banner topo')
        //console.log(this.bannerTopo)
      })
      .catch(error => {
        console.error(error);
      });

    axios.get('/Process/InsInstitucional/GetById/' + this.id)
      .then(response => {
        this.linhaTextoNoticia = response.data;
        this.carregaMetas(this.removerTagsHTML(this.linhaTextoNoticia.itiDescricao1), this.linhaTextoNoticia.itiNome);
        //console.log('this.linhaTextoNoticia')
        //console.log(this.linhaTextoNoticia)

      })
      .catch(error => {
        console.error(error);
      });
  },
}
</script>

<style scoped></style>